<template>
  <div>
    <el-container>
      <el-header>
        <div style="margin: 20px 0">
          <el-button type="primary" @click="openCreateToken" size="small">创建token</el-button>
        </div>
      </el-header>
      <el-main>
        <el-dialog title="设置权限" :visible.sync="dialogFormVisible1" width="100%" top="0vh" :fullscreen="true">
          <el-tree
            :data="data"
            show-checkbox
            default-expand-all
            node-key="_id"
            ref="tree"
            highlight-current
            :props="defaultProps">
          </el-tree>
          <div style="text-align: left;width: 100%;height: 120px;">
            <el-button type="primary" @click="getCheckedNodes">保存</el-button>
          </div>
        </el-dialog>
        <el-dialog
          title="提示"
          :visible.sync="centerDialogVisible"
          width="30%"
          center>
          <span>删除后将无法恢复，确定删除？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="deleteToken">确 定</el-button>
        </span>
        </el-dialog>
        <el-dialog  title="创建/编辑" :visible.sync="dialogFormVisible" top="3vh">
          <div class="demo-input-suffix">
            授权名称：<br/><br/>
            <el-input
              placeholder="请输入授权名称"
              v-model="name">
            </el-input>
          </div>
          <div class="demo-input-suffix">
            授权限制：
            <template>
              <el-radio-group v-model="radio" @change="typeChange">
                <el-radio label="无限制">无限制</el-radio>
                <el-radio label="时间">时间</el-radio>
                <el-radio label="次数">次数</el-radio>
              </el-radio-group>
            </template>
          </div>
          <div class="demo-input-suffix" v-show="timeDiv">
            时间：<br/><br/>
            <el-date-picker
              v-model="time"
              type="daterange"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <div class="demo-input-suffix" v-show="countDiv">
            次数：<br/><br/>
            <el-input
              type="number"
              placeholder="请输入次数"
              v-model="count">
            </el-input>
          </div>
          <div class="demo-input-suffix">
            所属客户：<br/><br/>
            <el-dropdown split-button type="primary" @command="commandUserEvent" style="margin-left: 10px;">
              <span v-html="dropdownTitle"></span>
              <el-dropdown-menu slot="dropdown" class="project-dropdown">
                <el-dropdown-item v-for="(item,index) in dropdownUserList" :key="index" :command="item.identification">{{item.customerName}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="qdCreateToken()">确 定</el-button>
          </div>
        </el-dialog>
        <template>
          <el-table
            :data="tableData"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              fixed
              prop="name"
              label="授权名称"
              width="180">
            </el-table-column>
            <el-table-column
              fixed
              prop="appId"
              label="appId"
              width="180">
            </el-table-column>
            <el-table-column
              fixed
              prop="appSecret"
              label="appSecret"
              width="180">
              <template slot-scope="scope">
                <span @click="getAppSecret(scope.row._id)" class="fontCssToken">{{scope.row.appSecret}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="startTime"
              label="开始时间"
              width="180">
            </el-table-column>
            <el-table-column
              prop="endTime"
              label="结束时间"
              width="180">
            </el-table-column>
            <el-table-column
              prop="count"
              label="次数"
              width="120">
            </el-table-column>
            <el-table-column
              prop="type"
              label="限制类型"
              width="120">
            </el-table-column>
            <el-table-column
              prop="count"
              label="状态操作"
              width="120">
              <template slot-scope="scope">
                <el-button @click="{{(scope.row.state?cz(1,scope.row._id):cz(2,scope.row._id))}}" type="text" size="small">{{(scope.row.state?'停用':'启用')}}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="updateTime"
              :formatter="formatTime"
              label="最后更新时间"
              width="180">
            </el-table-column>
            <el-table-column
              prop="createTime"
              :formatter="formatTime"
              label="创建时间"
              width="180">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="200">
              <template slot-scope="scope">
                <!--<el-button @click="updateUserRoot(scope.$index, scope.row)" type="text" size="small">设置权限</el-button>-->
                <el-button @click="updateToken(scope.$index, scope.row,3)" type="text" size="small">编辑</el-button>
                <el-button @click="updateToken(scope.$index, scope.row,4)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  export default {
    name: 'token',
    data(){
      return {
        count:0,
        time:"",
        timeDiv:false,
        countDiv:false,
        checked:false,
        classDiv:true,
        dropdownUserList:[],
        dropdownTitle:"请选择",
        dialogFormVisible:false,
        dialogFormVisible1:false,
        centerDialogVisible:false,
        tableData:[],
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        name:"",
        radio:"无限制",
        isType:1,
        isId:"",
        divHeight:500,
        data: [],
        defaultProps: {
          children: 'children',
          label: 'label',
          sort:'sort',
          level:'level',
          url:'url'
        }
      }
    },
    methods:{
      commandUserEvent(command) {
        this.dropdownTitle = command
      },
      addUser:async function(){
        await this.$axios.post('/root/addUser',{
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownUserList = response.data;
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy-MM-dd hh:mm:ss";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      openCreateToken:function (val) {
        this.isType == 1
        this.dialogFormVisible = true;
        this.addUser();
      },
      qdCreateToken:function () {
        this.isAjax();
      },
      isAjax:async function(){
        if(this.isType == 1) {
          if (this.name == "") {
            this.$message({
              message: "授权名称不能为空",
              type: 'warning'
            });
            return false;
          } else if (this.radio == "时间") {
            if (this.time == "") {
              this.$message({
                message: "请选择时间",
                type: 'warning'
              });
              return false;
            }
          } else if (this.radio == "次数") {
            if (this.count == "") {
              this.$message({
                message: "请输入次数",
                type: 'warning'
              });
              return false;
            } else if (this.count <= 0) {
              this.$message({
                message: "请输入次数要大于0",
                type: 'warning'
              });
              return false;
            }
          }else if(this.dropdownTitle == "" || this.dropdownTitle == "请选择"){
            this.$message({
              message: "请选择所属客户",
              type: 'warning'
            });
            return false;
          }
        }
        await this.$axios.post('/root/tokenMessage',{
          "t":this.isType,
          "name":this.name,
          "time":this.time,
          "count":this.count,
          "state":this.state,
          "type":this.radio,
          "id":this.isId,
          "identification":this.dropdownTitle
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            if(this.isType == 2){
              this.$message({
                message: response.message,
                type: 'success'
              });
            }else{
              this.$message({
                message: response.message,
                type: 'success'
              });
              this.dialogFormVisible = false;
              this.centerDialogVisible = false;
              this.time = "";
              this.count = "";
              this.name = "";
              this.userName = "";
            }
            this.addToken();
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }

        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      addToken:async function(){
        await this.$axios.post('/root/addToken',{}).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.tableData = response.data[0];
            this.allcount0 = response.data[1];
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
        this.divHeight = window.innerHeight-158;
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.addToken();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.addToken();
      },
      updateToken(index, row ,val) {
        this.isId = row._id;
        this.isType = val;
        if(val == 3){
          this.name = row.name;
          this.radio = row.type;
          if(row.type == "时间"){
            this.time = [row.startTime,row.endTime];
            this.ciountDiv = false;
            this.timeDiv = true;
          }else if(row.type == "次数"){
            this.timeDiv = false;
            this.ciountDiv = true;
            this.count = row.count;
          }
          this.dropdownTitle = row.identification?row.identification:"请选择";
          this.dialogFormVisible = true;
          this.addUser();
        }else if(val == 4){
          this.centerDialogVisible = true;
        }else{
          this.isAjax()
        }
      },
      cz(val,id){
        var isState = true;
        this.isId = id;
        if(val == 1){
          isState = false;
        }else if(val == 2){
          isState = true;
        }
        this.state = isState;
        this.isType = 2;
        this.isAjax();
      },
      getCheckedNodes:async function() {
        var _list = this.$refs.tree.getCheckedNodes(false,true);
        if(_list.length>0){
          await this.$axios.post('/root/addUserMenu',{
            "id":this.isId,
            "list":_list
          }).then((response,err) => {
            response = response.data;
            if(response.code == "Login" || response.code == "WhiteList"){
              this.$message.error(response.message);
            }else if(response.code == "Success"){
              this.$message({
                message: response.message,
                type: 'success'
              });
              this.dialogFormVisible1 = false;
              this.addToken();
            }else if(response.code == "Fail"){
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }else{
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }
          }).catch(function (error) {
            this.$message.error(error);
          });
        }else{
          this.$message({
            message: "请勾选功能菜单",
            type: 'warning'
          });
        }
      },
      isShowClass(){
        if(this.checked){
          this.classDiv = false;
        }else{
          this.classDiv = true;
        }
      },
      typeChange(){
        if(this.radio == "时间"){
          this.countDiv = false;
          this.timeDiv = true;
        }else if(this.radio == "次数"){
          this.timeDiv = false;
          this.countDiv = true;
        }else{
          this.countDiv = false;
          this.timeDiv = false;
        }
      },
      deleteToken(){
        this.isAjax();
      },
      getAppSecret:async function(id){
        await this.$axios.post('/root/pushAppSecret',{
          "id":id,
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.$message({
              message: response.message,
              type: 'success'
            });
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      }
    },
    mounted(){
      this.addToken();
    }
  }
</script>
<style scoped>
  body{
    padding: 0;
    margin: 0;
  }
  .demo-input-suffix{
    margin-bottom: 10px !important;
  }
  .fontCssToken{
    text-decoration-line: underline;
    color: #0a8cd2;
    cursor: pointer;
  }
  .project-dropdown{
    height:300px !important;
    overflow: auto;
  }
  .project-dropdown::-webkit-scrollbar
  {
    width: 5px;
    height: 5px;
    background-color: #F5F5F5;
  }
  .project-dropdown::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }
  .project-dropdown li{
    margin-bottom: 0px !important;
    text-align: center !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/main/token.vue